import { render, staticRenderFns } from "./ActivityAdmin.vue?vue&type=template&id=448e5158"
import script from "./ActivityAdmin.vue?vue&type=script&lang=js"
export * from "./ActivityAdmin.vue?vue&type=script&lang=js"
import style0 from "./ActivityAdmin.vue?vue&type=style&index=0&id=448e5158&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports